export default {
  title: 'Agrupamento de não conformidades',
  title_serviceOrder: 'Agrupamento de não conformidades de atividades',
  title_formReply: 'Agrupamento de não conformidades de formulários'
}
